import React from "react";
import Card from "../../components/Card";
import "./style.scss";
import { objCards } from "../../constants/SelectCardsActive";

import Swiper from "react-id-swiper";
const MutipleSlides = () => {
  const params = {
    dynamicBullets: true,
    spaceBetween: 40,
    pagination: {
      el: ".swiper-pagination",
      clickable: false
    },
    breakpoints: {
      1024: {
        slidesPerView: 3,
        spaceBetween: 150
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 60,
        slidesPerGroup: 3
      },
      375: {
        slidesPerView: 2,
        spaceBetween: 200
      },
      320: {
        slidesPerView: 1
      }
    }
  };
  return (
    <Swiper {...params}>
      {objCards.map(card => (
        <div key={card.title}>
          <Card
            img={card.img}
            title={card.title}
            description={card.description}
          />
        </div>
      ))}
    </Swiper>
  );
};

export default function SectionCardsActive() {
  return (
    <section className="container-section-cards">
      <div className="container-text">
        <p>Recebeu, ativou, usou.</p>
        <span>Fácil assim.</span>
      </div>
      {window.screen.width > 1024 ? (
        <div className="container-cards">
          {objCards.map(card => (
            <Card
              img={card.img}
              title={card.title}
              description={card.description}
              key={card.title}
            />
          ))}
        </div>
      ) : (
        <MutipleSlides />
      )}
    </section>
  );
}
